"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyLoggingConfig = applyLoggingConfig;
var console_log_handler_1 = require("./console-log-handler");
var debug_log_handler_1 = require("./debug-log-handler");
var logger_1 = require("./logger");
function applyLoggingConfig(logger, loggingConfig) {
    var _a;
    var debugMode = (_a = loggingConfig === null || loggingConfig === void 0 ? void 0 : loggingConfig.debugMode) !== null && _a !== void 0 ? _a : false;
    var logHandlers = loggingConfig === null || loggingConfig === void 0 ? void 0 : loggingConfig.logHandlers;
    if (!logHandlers || logHandlers.length === 0) {
        logHandlers = [(0, console_log_handler_1.createConsoleLogHandler)(logger_1.LogLevel.Warn)];
    }
    if (debugMode) {
        logHandlers = logHandlers.map(function (handler) { return (__assign(__assign({}, handler), { logLevel: logger_1.LogLevel.Verbose })); });
        logHandlers.push(debug_log_handler_1.debugLogHandler);
    }
    return logger.registerLogHandlers.apply(logger, logHandlers);
}
